import { Component } from '@angular/core';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { IGetEpisodesOfCare } from 'src/app/interfaces/IGetEpisodesOfCare';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { VisitExpandComponent } from '../visit-expand/visit-expand.component';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-active-eoc',
  templateUrl: './active-eoc.component.html',
  styleUrls: ['./active-eoc.component.css'],
  standalone: false,
})
export class ActiveEocComponent {
  public expandComp = VisitExpandComponent;

  private destroy$ = new Subject<void>();

  isLoading = false;
  episodesOfCare: IGetEpisodesOfCare[] = [];

  constructor(
    private readonly eocService: EpisodeOfCareService,
    private readonly localeService: LocaleService,
  ) {}

  ngOnInit() {
    this.eocService.activeEocLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.eocService.activeEocDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IGetEpisodesOfCare[]) => {
        this.episodesOfCare = data;
      });

    this.localeService.locale$
      .pipe(
        switchMap(() => this.eocService.loadActiveData()),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
